import { Fragment } from "react";
import { OwcHyperlink, OwcIcon, OwcTypography, OwcProgressSpinner } from "@one/react";
import {EquipmentDetailsDisplay} from "./EquipmentDetailsDisplay";

export const ViewChecklist = ({ equipmentDetails  = null, checklists = [], loading = false, error = null, minHeight = 300 }) => {
    return (
    <div style={{ width: "100%", minHeight }}>
      {equipmentDetails ? <EquipmentDetailsDisplay equipmentDetails={equipmentDetails}/> : null}
      <div style={{ height: "200px", overflowY: "auto", padding: "0 8px",  marginTop: "10px" }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <OwcProgressSpinner size="md" />
          </div>
        ) : error ? (
          <OwcTypography
            variant="caption"
            style={{
              color: "var(--one-color-red-600)",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            Error: {error}
          </OwcTypography>
        ) : checklists.length > 0 ? (
          checklists.map(({ url: link, description }, index) => (
            <Fragment key={index}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: "6px" }}>
                <OwcIcon name="link" type="outlined" />
                <OwcHyperlink
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: 260,
                  }}
                >
                  {description || "Checklist"}
                </OwcHyperlink>
              </div>
            </Fragment>
          ))
        ) : (
          <OwcTypography
            variant="caption"
            style={{
              textAlign: "center",
              fontStyle: "italic",
              color: "var(--one-color-gray-600)",
            }}
          >
            No checklists available
          </OwcTypography>
        )}
      </div>
    </div>
  );
};
